const PremiumHero = () => {
  return (
    <section className="relative pt-32 pb-16 md:pt-40 md:pb-20 overflow-hidden">
      {/* BG */}
      <div className="absolute inset-0 pointer-events-none">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20dark%20space%20with%20golden%20and%20amber%20neon%20light%20trails%2C%20luxury%20premium%20technology%20aesthetic%2C%20deep%20black%20background%20with%20warm%20gold%20glowing%20particles%20and%20streaks%2C%20cinematic%20wide%20angle%2C%20ultra%20high%20quality%20render&width=1400&height=700&seq=premhero&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-center opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#05070d]/80 via-[#05070d]/60 to-[#05070d]" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[400px] rounded-full bg-yellow-500/8 blur-[120px]" />
        <div className="absolute top-1/3 right-1/4 w-[300px] h-[300px] rounded-full bg-orange-500/6 blur-[80px]" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 md:px-8 text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2.5 px-5 py-2 rounded-full bg-gradient-to-r from-yellow-500/15 to-orange-500/15 border border-yellow-500/30 text-yellow-400 text-xs font-bold mb-8 backdrop-blur-sm">
          <i className="ri-vip-crown-line text-sm" />
          ChatNow Premium
          <span className="w-1 h-1 rounded-full bg-yellow-400/50 inline-block" />
          Ayrıcalıklı Deneyim
        </div>

        <h1 className="text-4xl sm:text-5xl md:text-7xl font-extrabold text-white leading-tight tracking-tight mb-6 max-w-4xl mx-auto">
          Premium ile Her Şey{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 via-orange-400 to-yellow-300">
            Daha İyi
          </span>
        </h1>

        <p className="text-white/50 text-base md:text-xl max-w-2xl mx-auto mb-10 leading-relaxed">
          Cinsiyet filtresi, ülke seçimi, reklamsız deneyim ve öncelikli eşleşme ile sohbet deneyimini bir üst seviyeye taşı.
        </p>

        {/* Quick stats */}
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
          {[
            { num: '500K+', label: 'Premium Üye' },
            { num: '3x', label: 'Daha Hızlı Eşleşme' },
            { num: '%100', label: 'Reklamsız' },
            { num: '4.9★', label: 'Kullanıcı Puanı' },
          ].map((s) => (
            <div key={s.label} className="text-center">
              <div className="text-xl md:text-2xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-400">
                {s.num}
              </div>
              <div className="text-white/35 text-xs mt-1">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PremiumHero;
